import http from '@/http'

const PATH = '/tools/scheduled-reports/bundles'

export default {
    /**
     * @param {ReportQuery} data
     * @returns {Promise<void>}
     */
    async listScheduledReports (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ScheduledReportQuery} uuid
     * @returns {Promise<void>}
     */
    async showScheduledReport (uuid) {
        try {
            const response = await http.get(`${PATH}/${uuid}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ScheduledReportInventoryItem} data
     * @returns {Promise<void>}
     */
    async createScheduledReport (data) {
        try {
            const response = await http.post(PATH, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ScheduledReportInventoryItem} uuid, data
     * @returns {Promise<void>}
     */
    async updateScheduledReport (uuid, data) {
        try {
            const response = await http.put(`${PATH}/${uuid}`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ScheduledReportItem} data
     * @returns {Promise<void>}
     */
    async removeScheduledReport (data) {
        try {
            const response = await http.delete(`${PATH}/${data.id}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{uuids: string[]}} data
     */
    async removeReports (data) {
        try {
            const response = await http.delete(PATH, {data})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
